import React from 'react';
import ProductList from '../components/products/ProductList';

const Attars = () => {
  return (
    <ProductList
      categorySlug="attars"
      categoryName="Attars"
      categoryDescription="Experience the rich tradition of authentic attars. Pure, alcohol-free, oil-based fragrances."
    />
  );
};

export default Attars;